export { ConfirmDialogComponent } from './confirm-dialog.component';
export { AlertDialogComponent } from './alert-dialog.component';
export { MessageDialogComponent } from './message-dialog.component';
export { CopyDialogComponent } from './copy-dialog.component';
export { VersionExpiredDialogComponent, VersionUpdateService, VersionUpdateState } from './version-expired-dialog.component';

export { DialogsModule } from './dialogs.module';
